import { createSlice } from '@reduxjs/toolkit';

interface AssetTagsState {
  showSaveSuccess: boolean;
}

const initialState: AssetTagsState = {
  showSaveSuccess: false,
};

const assetTagsV2Slice = createSlice({
  name: 'assetTagsV2',
  initialState,
  reducers: {
    setTagSaveSuccess(state) {
      state.showSaveSuccess = true;
    },
    clearTagSaveSuccess(state) {
      state.showSaveSuccess = false;
    },
  },
});

export const { setTagSaveSuccess, clearTagSaveSuccess } = assetTagsV2Slice.actions;
export default assetTagsV2Slice.reducer;
